import { type TblTacheTacheUpdatePriorityEnum } from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type TaskPriority = {
    value: TblTacheTacheUpdatePriorityEnum;
    label: string;
};

export const tasksPriorities = [
    {
        value: 0,
        label: 'Faible',
    },
    {
        value: 1,
        label: 'Moyenne',
    },
    {
        value: 2,
        label: 'Elevée',
    },
] as TaskPriority[];

export const getPriorityLabel = (value?: number): string => {
    const priority = tasksPriorities.find((task) => task.value === value);
    if (priority) {
        return priority.label;
    }
    return 'Faible';
};
